const countTotalQuantity = () => {
  let quantityInputs = Array.from(document.querySelectorAll('.wholesale-table__variant-input'));
  let totalQuantity = quantityInputs.reduce((acc, quantityInput) => {
    let quantityValue = Number(quantityInput.value);
    return acc + quantityValue;
  }, 0);

  console.log("TOTAL QUANTITY", totalQuantity);
  return totalQuantity;
}

const validateQuantity = (e) => {

  if (parseInt(e.target.value, 10) > parseInt(e.target.max, 10)) {
    e.target.classList.add('error');
    let errorMessage  = e.target.closest('.wholesale-table__variant').querySelector('.error-message');
    errorMessage.classList.add('active');
    e.target.value = 0;
    setTimeout(() => {
      errorMessage.classList.remove('active');
    }, 1000);
  } else {
    e.target.classList.remove('error');
  }

  toggleAddToCartButton();
}

const countErrors = () => {
  return document.querySelectorAll('.wholesale-table__variant-input.error').length;
}

const toggleAddToCartButton = () => {    
  let addToCartButton = document.getElementById('bulk-add-to-cart');
  if(countErrors() > 0 || countTotalQuantity() <= 0) {
    addToCartButton.setAttribute('disabled', '');
  } else {
    addToCartButton.removeAttribute('disabled');
  }
}

const addItemsToCart = () => {

  if(countErrors() > 0 || countTotalQuantity() <= 0) {
    return;
  }

  let quantityInputs = Array.from(document.querySelectorAll('.wholesale-table__variant-input'));

  quantityInputs = quantityInputs.filter(function(input) {
    return Number(input.value) > 0;
  });

  let items = quantityInputs.map((item) => {
    let variantId = item.dataset.variantId;
    let quantity = Number(item.value);

    return {
      "id": variantId,
      "quantity": quantity
    }
  });

  console.log("ITEMS: ", items);

  let data = {
    items: items
  }

  debugger

  fetch('/cart/add.js', {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((json) => {
    /* yay! our products were added */
    console.log('products', json);
    window.location.href = "/cart";
  }).catch((err) => {
    /* uh oh, we have error. */
    console.error(err)
  });
}

// window.addEventListener("load", (event) => {
//   let addToCartButton = document.getElementById('bulk-add-to-cart');
//   addToCartButton && addToCartButton.addEventListener('click', () => {
//     addItemsToCart();
//   });
// });